import { Container } from "@/components/layout/Container"
import AddToCartButton from "@/features/checkout/AddToCartButton"
import { imageBaseURL } from "@/lib/utils"
import type { ItemId } from "@/content/prices"

interface ProductCTAProps {
	/** Producto o servicio a agregar al carrito — solo se usan `id` y `priceId`. */
	item: { id: ItemId; priceId: string }
	cta: { title: string; text?: string }
}

/**
 * CTA final de la ficha de producto o servicio. Reutiliza el fondo y estilo de
 * `treatment/TreatmentCta`: degradado azul de marca con un motivo celular
 * superpuesto y texto blanco. El botón agrega el ítem al carrito, muestra el
 * toast y redirige al carrito (`/checkout`).
 */
export function ProductCTA({ item, cta }: ProductCTAProps): React.JSX.Element {
	const cartItem = { id: item.id, priceId: item.priceId, amount: 1 }

	return (
		<section className="relative isolate overflow-hidden bg-linear-to-br from-primary via-chart-3 to-chart-5 text-white">
			{/* Motivo celular abstracto */}
			<div
				aria-hidden
				className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-10 mix-blend-screen"
				style={{ backgroundImage: `url(${imageBaseURL("backgrounds/bg-cells-white.svg")})` }}
			/>
			<Container className="relative py-20 text-center md:py-28 lg:py-32">
				<h2 className="mx-auto max-w-2xl text-balance font-heading text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
					{cta.title}
				</h2>
				{cta.text && <p className="mx-auto mt-5 max-w-xl text-pretty text-lg text-white/85">{cta.text}</p>}
				<div className="mt-10 flex justify-center">
					<AddToCartButton
						cartItem={cartItem}
						redirectTo="/checkout"
						text="Agregar al carrito"
						size="lg"
						className="w-full bg-white text-primary hover:bg-white/90 sm:w-auto"
					/>
				</div>
			</Container>
		</section>
	)
}
